import React, { Component } from "react";
import TwitterLogin from "react-twitter-login";

import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { getSocialDetails, maketwitteroauthtoken } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getUserID, saveDatatoLocalStorage } from "../../util/utils";
import TopHeader from "../CommanComponents/TopHeader";
import LogoutMenu from "../CommanComponents/LogoutMenu";
class TwitterConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      twitter_consumer_key: "",
      twitter_consumer_secret: "",
    };
  }

  loginHandler = (err, data) => {
    if (data) {
      const { oauth_token, oauth_token_secret } = data;
      saveDatatoLocalStorage("oauth_token", oauth_token);
      saveDatatoLocalStorage("oauth_token_secret", oauth_token_secret);
      apiCall(
        METHOD.QUERY,
        maketwitteroauthtoken(oauth_token_secret, oauth_token, getUserID()),
        (data) => {
          toast.info(
            this.props.t("ConnectionPage.twitter_connect_successfully"))
        },
        (isLoading) => { },
        (data) => {
          toast.error(this.props.t(data.message));
        }
      );
    } else {
      toast.info(this.props.t("ConnectionPage.twitter_connect_fail"));
    }

  };

  componentDidMount() {
    apiCall(
      METHOD.QUERY,
      getSocialDetails(getUserID()),
      (data) => {
        this.setState({
          twitter_consumer_key: data.twitter_consumer_key,
          twitter_consumer_secret: data.twitter_consumer_secret,
        });
      },
      (isLoading) => { },
      (data) => {
        toast.error(this.props.t(data.message));

      }
    );
  }


  handleLoader = (status) => {
    this.setState({
      isLoading: status,
    });
  };
  render() {
    const { twitter_consumer_key, twitter_consumer_secret } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="wrapper position-relative">
              <div className="header-bg header-red sab-header1 sticky-top d-flex flex-column">
                <div className="container d-flex flex-column flex-fill">
                  <div className="text-center py-2 d-flex  align-items-center justify-content-between">
                    <TopHeader />
                    <p
                      className="mb-0 ml-auto text-light  pointer"
                      onClick={this.handleBackStack}
                    >
                      {t("ConnectionPage.twitter_connection")}
                    </p>
                    <LogoutMenu />
                  </div>
                </div>
              </div>
              <div className="middle-section sab-middle-section1">
                <TwitterLogin
                  consumerKey={twitter_consumer_key}
                  consumerSecret={twitter_consumer_secret}
                  authCallback={this.loginHandler}
                  children={
                    <button>{t("ConnectionPage.twitter_btn_lable")}</button>
                  }
                />
              </div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(TwitterConnection));